import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Only auto-download if this element was inserted via Turbo Stream
    // Check if the element has the 'auto-trigger' data attribute set by the turbo stream
    // This prevents auto-downloading on regular page loads
    if (this.element.dataset.autoTrigger === "true" && !this.element.dataset.downloaded) {
      this.element.dataset.downloaded = "true"
      
      // Use window.location.href for more reliable download triggering
      // This works better than .click() which is often blocked by popup blockers
      window.location.href = this.element.href
    }
  }
}
